
define('ldsh!modules/address/list/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Address</h1>\n<a class="btn btn-default" href="#/address/create">Create</a>\n<table class="table table-striped">\n\t<thead>\n  \n  <th>\n   workPhone\n  </th>\n  \n  <th>\n   homePhone\n  </th>\n  \n  <th>\n   mobile\n  </th>\n  \n  <th>\n   fax\n  </th>\n  \n  <th>\n   notes\n  </th>\n  \n  <th>\n   Street1\n  </th>\n  \n  <th>\n   Street2\n  </th>\n  \n  <th>\n   City\n  </th>\n  \n  <th>\n   State\n  </th>\n  \n  <th>\n   PostalCode\n  </th>\n\n  <th>\n\n  </th>\n    <th>\n\n  </th>\n\t</thead>\n\t<tbody class="Address-body">\n\t</tbody>\n</table>';

}
return __p
};});

